import { Component, OnInit, Input, SimpleChanges, Output, EventEmitter } from '@angular/core';
import { RelatiesService } from 'src/app/shared/dataservices/relaties.service';
import { ObjectenService } from 'src/app/shared/dataservices/objecten.service';
import { ConfirmDialogModel, ConfirmDialogComponent } from 'src/app/general/confirm-dialog/confirm-dialog.component';
import { MatDialog } from '@angular/material/dialog';
import { ToastrService } from 'ngx-toastr';
import { ObjectAfleveradres } from 'src/app/shared/model/object';
import { AfleverAdres } from 'src/app/shared/model/relatie';

@Component({
  selector: 'app-objectafleveradres-edit',
  templateUrl: './afleveradres-edit.component.html',
  styleUrls: ['./afleveradres-edit.component.less']
})
export class ObjectAfleveradresEditComponent implements OnInit {

@Input() afleveradres: AfleverAdres;
@Input() objectAfleverAdres : ObjectAfleveradres;
@Output() deleted = new EventEmitter();

relaties: any;
afleveradresList : any;
notChanged = true;

  constructor(private objectenService : ObjectenService,
              private dialog: MatDialog,
              private toastr: ToastrService) { }

  ngOnInit() {

  }



  delete() {
    const message = `Weet je zeker dat je dit wilt doen?`;

    const dialogData = new ConfirmDialogModel("Bevestig verwijdering", message);

    const dialogRef = this.dialog.open(ConfirmDialogComponent, {
      maxWidth: "400px",
      data: dialogData
    });

    dialogRef.afterClosed().subscribe(dialogResult => {
      const result = dialogResult;
      if (result) {
          this.objectenService.deleteObjectAfleveradres(this.objectAfleverAdres.ID).subscribe(data => {
             this.toastr.error("", "Verwijderd");
             this.deleted.emit(this.objectAfleverAdres.ID)
           }
           );
        }
      });

  }

  change(e) {
    this.notChanged=false;
  }


  textEntered(e){
    //this.searchText = e;
  }

  valueSelected(e){
    //this.selectedObject = JSON.stringify(e);
  }

}
